export const insertPlacesBulk = cities => dispatch => {
  fetch("/api/places/insert-bulk-targetable-places")
    .then(res => res.json())
    .then(res => console.log(res));
};
